/** Frame the supplied transparent artboards without altering the original artwork. */
export default function BrandRibbon({ className = '' }) {
  return <div className={`haramain-ribbon ${className}`} aria-hidden="true" />;
}
